import { render, staticRenderFns } from "./coparticipation.vue?vue&type=template&id=e396d424"
import script from "./coparticipation.vue?vue&type=script&lang=js"
export * from "./coparticipation.vue?vue&type=script&lang=js"
import style0 from "./coparticipation.vue?vue&type=style&index=0&id=e396d424&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports